import axios from 'axios'
import { BUSCAR_ROTAS_CONTROLE_EMISSAO_BPE } from '../types'
import { URL } from '../../util/ambienteActions';

export default function buscarRotasControleEmissaoBpe (empresaId) {
  const url = `${URL}/controle-emissao-bpe/rotas/empresa/${empresaId}`;

  return dispatch => axios.get(url).then(
      response => {
        dispatch({
          type: BUSCAR_ROTAS_CONTROLE_EMISSAO_BPE,
          payload: response
        });
        return { payload: response };
      }
  );
}
